'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var fetch = require('isomorphic-fetch');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var fetch__default = /*#__PURE__*/_interopDefaultLegacy(fetch);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var DEFAULT_TIMEOUT = 5000;
var RESPONSE_TYPES = {
  TEXT: 'text',
  JSON: 'json'
};
var windowProtocol;

var isValidTimeout = function isValidTimeout(timeout) {
  return timeout > 0;
};

var identity = function identity(value) {
  return value;
};

var tryParseResponseBody = function tryParseResponseBody(res) {
  var contentType = RESPONSE_TYPES.TEXT;

  if (res && res.headers && res.headers.get) {
    var contentTypeStr = res.headers.get('content-type');
    contentType = contentTypeStr && contentTypeStr.toLowerCase().indexOf('json') > -1 ? RESPONSE_TYPES.JSON : contentType;
  }

  return res[contentType] ? res[contentType]() : Promise.resolve('An error occurred in baseFetch tryParseResponseBody');
};

var createErrorIfBadStatusCode = function createErrorIfBadStatusCode(res) {
  if (res && res.status >= 400) {
    return tryParseResponseBody(res).then(function (body) {
      var err = new Error("Request to ".concat(res.url, " failed with status ").concat(res.status));
      err.status = res.status;
      err.statusText = res.statusText;
      err.response = body;
      return err;
    });
  }

  return res;
};

var throwIfError = function throwIfError(res) {
  if (res && res.constructor === Error) {
    throw res;
  }

  return res;
};

var baseFetch = function baseFetch(baseUrl) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!options.caller) {
    throw new Error('Option "caller" MUST be supplied to fetch!');
  }

  var ptr = {};
  var promise = new Promise(function (resolve, reject) {
    ptr.resolve = resolve;
    ptr.reject = reject;
  });
  var handleResponse = options.dontThrowOnBadStatus ? identity : createErrorIfBadStatusCode; // eslint-disable-next-line no-param-reassign

  options.headers = options.headers || {}; // eslint-disable-next-line no-param-reassign

  options.headers['x-caller-app'] = options.caller;

  var optionsToUse = _objectSpread(_objectSpread({}, options), {}, {
    timeout: isValidTimeout(options.timeout) && +options.timeout || DEFAULT_TIMEOUT
  });

  if (!baseUrl) {
    return Promise.reject(new Error('Cannot fetch empty url'));
  }

  if (typeof baseUrl !== 'string') {
    return Promise.reject(new Error('Unable to fetch non-string url'));
  } // Should this not use the timeout from optionsToUse instead?


  if (options.timeout && typeof window !== 'undefined') {
    ptr.timeout = setTimeout(function () {
      return ptr.reject(new Error('Request timed out'));
    }, options.timeout);
  }

  if (baseUrl.substring(0, 4).toLowerCase() === 'http') {
    fetch__default["default"](baseUrl, optionsToUse).then(function (v) {
      // eslint-disable-next-line no-unused-expressions
      ptr.timeout && clearTimeout(ptr.timeout);
      return v;
    }).then(handleResponse).then(throwIfError).then(ptr.resolve)["catch"](ptr.reject);
    return promise;
  }
  /* eslint-disable no-undef */


  windowProtocol = windowProtocol || typeof window !== 'undefined' && window.location && window.location.protocol;
  var protocol = windowProtocol || 'http:';
  /* eslint-enable no-undef */

  var url;

  if (baseUrl.indexOf('//') === 0) {
    url = "".concat(protocol).concat(baseUrl);
  } else if (baseUrl.indexOf('/') === 0) {
    url = baseUrl;
  } else {
    url = "".concat(protocol, "//").concat(baseUrl);
  }

  fetch__default["default"](url, optionsToUse).then(function (v) {
    // eslint-disable-next-line no-unused-expressions
    ptr.timeout && clearTimeout(ptr.timeout);
    return v;
  }).then(handleResponse).then(throwIfError).then(ptr.resolve)["catch"](ptr.reject);
  return promise;
};

exports.baseFetch = baseFetch;
//# sourceMappingURL=baseFetch.js.map
